module.exports = __webpack_public_path__ + "img/H3.a0d35ced.png";